import { Inject, Injectable } from '@angular/core';
import { UZURV_REST_CONFIGURATION, UzurvRestConfiguration, UzurvRestService } from '@uzurv/http';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { OrganizationPaymentAccount } from '@uzurv/clara';
import { map } from 'rxjs/operators';
import { Deserialize, Serialize } from 'cerialize';

@Injectable({
  providedIn: 'root'
})
export class OrganizationPaymentAccountService extends UzurvRestService {
  readonly resourceUrl = 'organizationPaymentAccounts/';

  constructor(
    httpClient: HttpClient,
    @Inject(UZURV_REST_CONFIGURATION)
    protected uzurvRestConfiguration: UzurvRestConfiguration,
    protected domSanitizer: DomSanitizer
  ) {
    super(httpClient, uzurvRestConfiguration, domSanitizer);
  }

  listOrganizationPaymentAccounts(): Observable<Array<OrganizationPaymentAccount>> {
    return this.get<Array<OrganizationPaymentAccount>>(`${this.resourceUrl}`).pipe(
      map(response => Deserialize(response, OrganizationPaymentAccount))
    );
  }

  /**
   * @param organizationPaymentAccount
   */
  createOrganizationPaymentAccount(organizationPaymentAccount: OrganizationPaymentAccount): Observable<OrganizationPaymentAccount> {
    return this.post<OrganizationPaymentAccount>(`${this.resourceUrl}`, Serialize(organizationPaymentAccount)).pipe(
      map(response => {
        return Deserialize(response, OrganizationPaymentAccount);
      })
    );
  }

  /**
   * @param organizationPaymentAccountId
   */
  deleteOrganizationPaymentAccount(organizationPaymentAccountId: number): Observable<boolean> {
    return this.delete(`${this.resourceUrl}${organizationPaymentAccountId}`);
  }

  /**
   * @param organizationPaymentAccount
   */
  updateOrganizationPaymentAccount(organizationPaymentAccount: OrganizationPaymentAccount): Observable<OrganizationPaymentAccount> {
    return this.put<OrganizationPaymentAccount>(
      `${this.resourceUrl}${organizationPaymentAccount.id}`,
      Serialize(organizationPaymentAccount)
    ).pipe(
      map(response => {
        return Deserialize(response, OrganizationPaymentAccount);
      })
    );
  }
}
